import { render, staticRenderFns } from "./AdminCreatePage.vue?vue&type=template&id=70470842"
import script from "./AdminCreatePage.vue?vue&type=script&lang=js"
export * from "./AdminCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70470842')) {
      api.createRecord('70470842', component.options)
    } else {
      api.reload('70470842', component.options)
    }
    module.hot.accept("./AdminCreatePage.vue?vue&type=template&id=70470842", function () {
      api.rerender('70470842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admins/AdminCreatePage.vue"
export default component.exports